import cn from "classnames";
import style from "./style.module.css";

type StrengthVariant = "WEAK" | "AVERAGE" | "STRONG";
interface StrengthPillProps {
  score: number;
}

export function getStrengthFromScore(score: number): StrengthVariant {
  if (score <= 1) return "WEAK";
  if (score <= 3) return "AVERAGE";
  return "STRONG";
}

export function StrengthPill({ score }: StrengthPillProps) {
  const variant = getStrengthFromScore(score);
  return <span className={cn(style.pill, style[variant.toLowerCase()])}>{variant}</span>;
}
